<template>
    <v-stepper :value="stepper"
               @change="updateStepOnClick"
               full-width>
        <v-container v-if="Object.keys(errors).length > 0" class="pb-0">
            <error-list :errors="errors"></error-list>
        </v-container>
        <v-stepper-header>
            <template v-for="(step, index) in steps">
                <v-stepper-step :key="index+1"
                                :step="index+1"
                                :rules="[() => { return validateStep(index) }]"
                                :editable="!validateStep(index)"
                                :complete="stepper > index+1"></v-stepper-step>
                <v-divider v-if="index+1 !== maxSteps"></v-divider>
            </template>
        </v-stepper-header>

        <v-stepper-items>
            <template v-for="(step, index) in steps">
                <v-stepper-content :key="index+1"
                                   :step="index+1"
                                   class="pt-0 pb-6">

                    <v-slide-left-transition mode="out-in">
                        <div v-if="step.completed && completed">
                            <h2 class="title">
                                {{ $vuetify.lang.t(step.completed.title) }}
                            </h2>
                            <p class="desc">
                                {{ $vuetify.lang.t(step.completed.description) }}
                            </p>
                        </div>

                        <build-form v-else
                                    :title="step.title"
                                    :description="step.description"
                                    :form-items="step.formItems"
                                    :actions="step.actions"
                                    :rules="rules"
                                    :form.sync="form"
                                    :ref="`formStep${index+1}`"
                                    :nextStep="nextStep"
                                    :previousStep="previousStep"/>

                    </v-slide-left-transition>

                </v-stepper-content>
            </template>
        </v-stepper-items>
    </v-stepper>
</template>
<script>
    import BuildForm from './BuildForm';
    import ErrorList from '../ErrorList';

    export default {
        name: 'build-stepper-form',
        components: {
            BuildForm,
            ErrorList,
        },
        props: {
            stepper: {}, // sync
            steps: {}, // -
            completed: {}, // sync
            form: {}, // sync
            errors: {}, // sync
            rules: {}, // -
        },
        computed: {
            maxSteps() {
                return this.steps.length;
            },
        },
        methods: {
            validateStep(index) {
                const currentStep = this.steps[index];

                let stepHasError = false;
                currentStep.formItems.map(formItem => {
                    if (!stepHasError) {
                        stepHasError = Object.keys(this.errors).includes(formItem.name);
                    }
                });
                return !stepHasError;
            },
            validateCurrentFormBeforeSubmit() {
                return this.$refs[`formStep${this.stepper}`][0];
            },
            updateStepOnClick(step) {
                this.$emit('update:stepper', step);
            },
            previousStep() {
                this.$emit('update:stepper', this.stepper - 1);
            },
            nextStep() {
                this.$emit('update:stepper', this.stepper + 1);
            },
        },
    }
</script>
